export const GLOBAL_COUNTERPARTY_SEARCH = 'src/components/Corporate/action/Global_Counterparty_Search';
export const GLOBAL_COUNTERPARTY_SEARCH_SUCCESS = 'src/components/Corporate/action/Global_Counterparty_Search_Success';
export const GLOBAL_COUNTERPARTY_SEARCH_FAILURE = 'src/components/Corporate/action/Global_Counterparty_Search_Failure';
export const globalCounterpartySearch = (data) => {
    return {
        type: GLOBAL_COUNTERPARTY_SEARCH,
        data
    }
}
export const globalCounterpartySearchSuccess = (data) => {
    return {
        type: GLOBAL_COUNTERPARTY_SEARCH_SUCCESS,
        data
    }
}
export const globalCounterpartySearchFailure = (error) => {
    return {
        type: GLOBAL_COUNTERPARTY_SEARCH_FAILURE,
        error
    }
}

export const ADVANCED_GLOBAL_COUNTERPARTY_SEARCH = 'src/components/Corporate/action/Advanced_Global_Counterparty_Search';
export const ADVANCED_GLOBAL_COUNTERPARTY_SEARCH_SUCCESS = 'src/components/Corporate/action/Advanced_Global_Counterparty_Search_Success';
export const ADVANCED_GLOBAL_COUNTERPARTY_SEARCH_FAILURE = 'src/components/Corporate/action/Advanced_Global_Counterparty_Search_Failure';
export const advancedGlobalCounterpartySearch = (search, stateList) => {
    return {
        type: ADVANCED_GLOBAL_COUNTERPARTY_SEARCH,
        search,
        stateList
    }
}
export const advancedGlobalCounterpartySearchSuccess = (data) => {
    return {
        type: ADVANCED_GLOBAL_COUNTERPARTY_SEARCH_SUCCESS,
        data
    }
}
export const advancedGlobalCounterpartySearchFailure = (error) => {
    return {
        type: ADVANCED_GLOBAL_COUNTERPARTY_SEARCH_FAILURE,
        error
    }
}

export const SEARCH_PARAMETER = 'src/components/Corporate/action/Search_Parameter';

export const searchParameter = (search) => {
    return {
        type: SEARCH_PARAMETER,
        search
    }
}

export const SEARCH_TEXT = 'src/components/Corporate/action/Search_Text';

export const searchText = (search) => {
    return {
        type: SEARCH_TEXT,
        search
    }
}

export const COUNTRY_NAME = 'src/components/Corporate/action/Country_Name';

export const countryName = (countryName) => {
    return {
        type: COUNTRY_NAME,
        countryName
    }
}

export const COUNTRY_CODE = 'src/components/Corporate/action/Country_Code';

export const countryCode = (countryCode) => {
    return {
        type: COUNTRY_CODE,
        countryCode
    }
}

export const VIEW_SELECTED_COUNTERPARTY = 'src/components/Corporate/action/View_Selected_Counterparty';
export const VIEW_SELECTED_COUNTERPARTY_SUCCESS = 'src/components/Corporate/action/View_Selected_Counterparty_Success';
export const VIEW_SELECTED_COUNTERPARTY_FAILURE = 'src/components/Corporate/action/View_Selected_Counterparty_Failure';
export const viewSelectedCounterparty = (id,reportCategory) => {
    return {
        type: VIEW_SELECTED_COUNTERPARTY,
        id,reportCategory
    }
}
export const viewSelectedCounterpartySuccess = (data) => {
    return {
        type: VIEW_SELECTED_COUNTERPARTY_SUCCESS,
        data
    }
}
export const viewSelectedCounterpartyFailure = (error) => {
    return {
        type: VIEW_SELECTED_COUNTERPARTY_FAILURE,
        error
    }
}

export const SET_CORPORATE_COLOR = 'src/components/Corporate/action/Set_Corporate_Color';
export const SET_CORPORATE_COLOR_SUCCESS = 'src/components/Corporate/action/Set_Corporate_Color_Success';
export const SET_CORPORATE_COLOR_FAILURE = 'src/components/Corporate/action/Set_Corporate_Color_Failure';

export const setCorporateColor = (data) => {
    return {
        type: SET_CORPORATE_COLOR,
        data
    }
}
export const setCorporateColorSuccess = (data) => {
    return {
        type: SET_CORPORATE_COLOR_SUCCESS,
        data
    }
}
export const setCorporateColorFailure = (data) => {
    return {
        type: SET_CORPORATE_COLOR_FAILURE,
        data
    }
}

export const SET_GLOBAL_SEARCHBOX_SHOW = 'src/components/Corporate/action/Set_Global_Searchbox_Show';
export const setGlobalSearchBoxShow = (data) => {
    return {
        type: SET_GLOBAL_SEARCHBOX_SHOW,
        data
    }
}